// The template's Metadate field, which caiet UC-ALRT-04 requires and which no
// screen offered although `notification_template.metadata` (jsonb) and the whole
// DTO chain already carried it. The wireframe writes it as `cheie=valoare` pairs
// (`wireframes/react/src/lib/admin-data.ts:1137`); the editor takes one pair per
// line so a value containing a comma survives the round trip.
//
// Only string values are written back. Metadata that already holds a number, a
// boolean or a nested object is rendered as JSON in the text and re-read as JSON,
// so an editor that never touches the field cannot flatten what it did not write.

function renderValue(value: unknown): string {
  if (typeof value === 'string') return value;
  return JSON.stringify(value);
}

function parseValue(raw: string): unknown {
  const trimmed = raw.trim();
  if (trimmed === '') return '';
  // Only these shapes were ever emitted as JSON above; anything else is text and
  // stays text, so `cheie=1 000` does not silently become the number 1.
  if (/^(true|false|null|-?\d+(\.\d+)?|[[{].*[\]}])$/.test(trimmed)) {
    try {
      return JSON.parse(trimmed);
    } catch {
      return raw;
    }
  }
  return raw;
}

export function metadataToText(metadata: Record<string, unknown> | null | undefined): string {
  if (!metadata) return '';
  return Object.entries(metadata)
    .map(([key, value]) => `${key}=${renderValue(value)}`)
    .join('\n');
}

export function textToMetadata(text: string): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const line of text.split('\n')) {
    const at = line.indexOf('=');
    if (at <= 0) continue;
    const key = line.slice(0, at).trim();
    if (!key) continue;
    out[key] = parseValue(line.slice(at + 1));
  }
  return out;
}
